import * as React from "react";

import "./css/updateuserpw.css"
import { checkSession , fluentd_s3} from './api/comm';
import { nexGrantAccess, nexSignin, nexUpdateUserPassword} from './api/nex';
import ReactNotify from 'react-notify';

import ReactLoading from 'react-loading';


const Loading = () => (
  <ReactLoading type="spinningBubbles" color="#ff8800" height={'20%'} width={'20%'} />
);


export class Unlockswap extends React.Component {
  constructor(props) {
    super(props);
  
    this.sessionData =  checkSession()
   
    this.state = {
      // idcard: "",
      // newpw: "",
      env: 'prod',
      waitcursor: false
    }
  }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value.replace(/\s/g, ''),
    })
    e.preventDefault();
  }

  handleSubmit(event) {

      this.setState({
        waitcursor: true
       });
    let log_body = {
      category: "kinunlockswap",
      env: this.sessionData[1].env,
      uid: this.sessionData[1]['mystiqueAuth'].uid,
      // idcard: this.state.idcard,
      // newpw: this.state.newpw
    }

    nexSignin(this.sessionData[1])
    .then((data) => {
        return nexGrantAccess(data)
    }).then((data) => {
      return nexUpdateUserPassword( Object.assign({body:{idcard:this.state.idcard, newPassword:this.state.newpw}}, this.sessionData[1]))
    }).then(data => {
        this.showNotification('INFO',`Unlock swap for all vehicles of KIN Done`);
        this.setState({
          idcard: '',
          newpw: '',
          waitcursor: false
         });
         log_body['status'] = 'success'
         this.setState({waitcursor: false})
       return fluentd_s3(log_body)
    
      })
      .catch(error => {
           this.showNotification('ERROR',`Unable update vehicle data`);
           log_body['status'] = error
           fluentd_s3(log_body)
           this.setState({waitcursor: false})
      });
    
    event.preventDefault();
  }


  componentDidMount() {
    const session = checkSession()
    if (!session[0]){
        // this.props.history.push("/login");
    }
    document.title = "Noodoe Admin System";
    
  }

  showNotification(type, content) {
    
    if ( type === 'INFO') this.refs.notificator.info(type, content, 3000);
    if ( type === 'ERROR') {
      this.setState({
        idcard: '',
        newpw: '',
        waitcursor: false
       });
      this.refs.notificator.error(type, content, 3000);
    }
  }
  
  render() {
    const env = this.sessionData[1] ? this.sessionData[1].env : "null";
   
    let display =
      <div id="parent">
        <pre>Please press on Submit buuton to unlock swap for all vehicles (only for KIN) (current env:{env})
          </pre>
        <form onSubmit={(e) => this.handleSubmit(e)}>
          <br />
          <input type="submit" value="Submit" style={{ fontSize: '24px', height: "30px", width: "600px" }} />
        </form>
        <ReactNotify ref='notificator' />
        {this.state.waitcursor ? Loading(): <div/> }
      </div>;

    return (
      <div>
        {display}
      </div>
    );
   }
  // }
}

